// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"4099e0cf","649":"1e1a2fe9","757":"a8d6b191"}[chunkId] + ".chunk.js";
};